import BookDetails, { BookDetailsType } from './BookDetails';

export default BookDetails;
export type { BookDetailsType };
